import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  FormControl,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { useFormContext } from "react-hook-form";

export default function Address() {
  const {
    register,
    handleSubmit,
    watch,
    control,
    setError,
    clearErrors,
    setValue,
    getValues,
    reset,
    trigger,
    formState: { errors, submitCount },
  } = useFormContext({
    defaultValues: {
      emailStr: "",
      zip: "", // 우편번호
      addr: "", // 주소
      addrDtl: "", // 상세주소
    },
  });

  watch("zip", false);
  watch("addr", false);
  watch("addrDtl", false);

  let element_wrap = document.getElementById("wrap");

  const foldDaumPostcode = () => {
    element_wrap.style.display = "none";
  };

  const openMap = () => {
    // 현재 scroll 위치를 저장해놓는다.
    var currentScroll = Math.max(
      document.body.scrollTop,
      document.documentElement.scrollTop
    );
    new daum.Postcode({
      oncomplete: function(data) {
        // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        var addr = ""; // 주소 변수
        var extraAddr = ""; // 참고항목 변수

        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === "R") {
          // 사용자가 도로명 주소를 선택했을 경우
          addr = data.roadAddress;
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          addr = data.jibunAddress;
        }

        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
        if (data.userSelectedType === "R") {
          // 법정동명이 있을 경우 추가한다. (법정리는 제외)
          // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            extraAddr += data.bname;
          }
          // 건물명이 있고, 공동주택일 경우 추가한다.
          if (data.buildingName !== "" && data.apartment === "Y") {
            extraAddr +=
              extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
          }
          // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
          if (extraAddr !== "") {
            extraAddr = " (" + extraAddr + ")";
          }
          // 조합된 참고항목을 해당 필드에 넣는다.
          setValue("addr", extraAddr, {
            shouldValidate: true,
          });
          // document.getElementById("sample3_extraAddress").value = extraAddr;
        } else {
          setValue("addr", "");
          // document.getElementById("sample3_extraAddress").value = "";
        }

        // 우편번호와 주소 정보를 해당 필드에 넣는다.
        setValue("zip", data.zonecode);
        setValue("addr", addr, {
          shouldValidate: true,
        });

        document.querySelector("#addrDtl").focus();

        // document.getElementById("sample3_postcode").value = data.zonecode;
        // document.getElementById("sample3_address").value = addr;
        // // 커서를 상세주소 필드로 이동한다.
        // document.getElementById("sample3_detailAddress").focus();

        // iframe을 넣은 element를 안보이게 한다.
        // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
        element_wrap.style.display = "none";

        // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
        document.body.scrollTop = currentScroll;
      },
      // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
      onresize: function(size) {
        console.log("size.height", size.height);
        // element_wrap.style.height = size.height + "px";
        // element_wrap.style.height = "350px";
      },
      width: "100%",
      height: "100%",
    }).embed(element_wrap);

    // iframe을 넣은 element를 보이게 한다.
    element_wrap.style.display = "block";
  };
  return (
    <>
      <InputLabel>주소</InputLabel>
      <Grid container spacing={1} className="inner-grid">
        <Grid item xs={12}>
          <Grid container spacing={1} className="item-grid">
            <Grid item xs={7}>
              <OutlinedInput
                type="text"
                {...register("zip")}
                readOnly
                disabled
                aria-label="postcode"
                placeholder="주소를 입력해주세요."
                onClick={openMap}
              />
            </Grid>
            <Grid item xs={5} style={{ paddingLeft: "8px" }}>
              <Button
                variant="contained"
                color="common"
                onClick={openMap}
                style={{ lineHeight: 1.3 }}
              >
                우편번호 검색
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <OutlinedInput
            type="search"
            name="addr"
            {...register("addr")}
            readOnly
            disabled
            aria-label="address"
            onClick={openMap}
          />
        </Grid>
        <Grid item xs={12}>
          <OutlinedInput
            id="addrDtl"
            name="addrDtl"
            {...register("addrDtl", {
              required: getValues("addr") ? true : false,
            })}
            disabled={getValues("addr") ? false : true}
            aria-label="address-detail"
            placeholder="상세주소를 입력해주세요."
          />
          {getValues("addr") && errors.addrDtl?.type === "required" && (
            <FormHelperText id="error-email" className="error">
              상세주소를 입력해주세요.
            </FormHelperText>
          )}
        </Grid>
      </Grid>

      <div id="wrap" className="map">
        <div className="clseBtn">
          <img
            src={`${process.env.PUBLIC_URL}/images/icon/close.svg`}
            id="btnFoldWrap"
            onClick={foldDaumPostcode}
            alt="접기 버튼"
          />
        </div>
      </div>
    </>
  );
}
